import { render, staticRenderFns } from "./MediaTreeFolder.vue?vue&type=template&id=d05d7068&scoped=true"
import script from "./MediaTreeFolder.vue?vue&type=script&lang=js"
export * from "./MediaTreeFolder.vue?vue&type=script&lang=js"
import style0 from "./MediaTreeFolder.vue?vue&type=style&index=0&id=d05d7068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05d7068",
  null
  
)

export default component.exports